
import * as types from "./actionTypes";
import * as approvalApi from '../../api/approvalsApi';

export function fetchBranchesByCompanyId(parameters) {
  return function (dispatch) {
    return approvalApi
      .getBranchesByCompanyId(parameters)
      .then(branches => {
        // separate action creator for successfull api call
        dispatch({
          type: types.FETCH_BRANCHES_BY_COMPANY_ID_SUCCESS,
          branches
        });
      })
      .catch(error => {
        throw error;
      });
  };
}


export function fetchDivisionsByBranchId(parameters) {
  return function (dispatch) {
    return approvalApi
      .getDivisionsByBranchId(parameters)
      .then(divisions => {
        // separate action creator for successfull api call
        dispatch({
          type: types.FETCH_DIVISIONS_BY_BRANCH_ID_SUCCESS,
          divisions
        });
      })
      .catch(error => {
        throw error;
      });
  };
}


export function fetchDepartmentsByCompanyIdBranchIdDivisionId(parameters) {
  return function (dispatch) {
    return approvalApi
      .getDepartmentsByCompanyIdBranchIdDivisionId(parameters)
      .then(departments => {
        // separate action creator for successfull api call
        dispatch({
          type: types.FETCH_DEPARTMENTS_BY_COMPANY_ID_BRANCH_ID_DIVISION_ID_SUCCESS,
          departments
        });
      })
      .catch(error => {
        throw error;
      });
  };
}

export function fetchResourceCollectionsByUserIdGeneralIdCompanyId(parameters) {
  return function (dispatch) {
    return approvalApi
      .getResourceCollectionsByUserIdGeneralIdCompanyId(parameters)
      .then(resourceCollections => {
        // separate action creator for successfull api call
        dispatch({
          type: types.FETCH_RESOURCE_COLLECTIONS_BY_USER_ID_GENERAL_ID_COMPANY_ID_SUCCESS,
          resourceCollections
        });
      })
      .catch(error => {
        throw error;
      });
  };
}

export function fetchTourApprovals(parameters) {
  return function (dispatch) {
    return approvalApi
      .getTourApprovals(parameters)
      .then(tourApprovals => {
        // separate action creator for successfull api call
        dispatch({
          type: types.FETCH_TOUR_APPROVALS_SUCCESS,
          tourApprovals
        });
      })
      .catch(error => {
        throw error;
      });
  };
}

export function fetchTimeKeeperReversalsByResourceDayTypeId(parameters) {
  return function (dispatch) {
    return approvalApi
      .getTimeKeeperReversalsByResourceDayTypeId(parameters)
      .then(reversal => {
        dispatch({
          type: types.FETCH_TIME_KEEPER_REVERSALS_BY_RESOURCE_DAY_TYPE_ID,
          reversal
        });
      })
      .catch(error => {
        throw error;
      });
  }
}

export function fetchTourIsDirectBillingCheckByTourId(parameters) {
  return function (dispatch) {
    return approvalApi
      .getTourIsDirectBillingCheckByTourId(parameters)
      .then(directBilling => {
        dispatch({
          type: types.FETCH_TOUR_IS_DIRECT_BILLING_BY_TOUR_ID,
          directBilling
        });
      })
      .catch(error => {
        throw error;
      });
  }
}

export function fetchContactInfoByTourId(parameters) {
  return function (dispatch) {
    return approvalApi
      .getContactInfoByTourId(parameters)
      .then(info => {
        dispatch({
          type: types.FETCH_CONTACT_INFO_BY_TOUR_ID,
          info
        });
      })
      .catch(error => {
        throw error;
      });
  }
}

export function addTourReversal(parameters) {
  return function (dispatch) {
    return approvalApi
      .createTimeKeeperReversal(parameters)
      .then(response => {
        dispatch({
          type: types.ADD_TOUR_REVERSAL,
          response
        });
      })
      .catch(error => {
        throw error;
      });
  }
}

export function updateApprovalParameters(parameters) {
  return function (dispatch) {
    dispatch({
      type: types.EDIT_APPROVAL_PARAMETERS_SUCCESS,
      parameters
    });
  }
}

export function updateTourApprovals(parameters) {
  return function (dispatch) {
    return approvalApi
      .updateTourApprovals(parameters)
      .then(response => {
        dispatch({
          type: types.EDIT_APPROVALS_SUCCESS,
          response
        });
      })
      .catch(error => {
        throw error;
      });
  }
}


// WEBPACK FOOTER //
// ./src/redux/actions/approvalActions.js